import { stopPropagation } from '../../../utils/events'
import ButtonComponent from '../../Button'
import { useSelectContext } from '../Select.hooks'

import { getButtonIconSelectControlProps } from './ButtonIconSelectControl.utils'

function ButtonIconSelectControl({
  Button = ButtonComponent.Flat,
  buttonProps,
  getButtonProps = getButtonIconSelectControlProps,
  ref,
  refs,
  ...restProps
}) {
  const { blocked, disabled, handleToggleOpen } = useSelectContext()

  function handleClick(event) {
    stopPropagation(event)

    if (!disabled && !blocked) {
      handleToggleOpen()
    }
  }

  const preparedButtonProps = getButtonProps(buttonProps)

  return (
    <div {...restProps} ref={refs.setReference || ref} onClick={handleClick}>
      <Button {...preparedButtonProps} />
    </div>
  )
}

export default ButtonIconSelectControl
